module.exports = __webpack_public_path__ + "static/media/BigY-Logo.8a2e04c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/whereToBuy/stores/BigY-Logo.png
// module id = 251
// module chunks = 0